// ============================================
// Peptides 101 - primer illustrations.
//
// Inline SVG line art matching the wizard's illustration language
// (illustrations.tsx): stroke = currentColor so it adapts to light/dark
// for free, with one var(--color-accent) highlight per figure. Weightless,
// no bundled assets, crisp at any size. One figure per primer card,
// keyed by card id ('what' | 'how' | 'taking').
// ============================================

import React from 'react';

const FILL = 'var(--color-accent)';

// ---- "What even is a peptide?" -----------------------------
// A short chain of linked beads: a peptide is a chain of building blocks,
// with one bead highlighted as the active "message".
export const PeptideChain: React.FC = () => (
  <svg className="lp-illus" viewBox="0 0 240 120" role="img" aria-label="A peptide is a short chain of linked building blocks, like beads on a string." fill="none">
    <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <line x1="58" y1="60" x2="82" y2="60" />
      <line x1="108" y1="60" x2="132" y2="60" />
      <line x1="158" y1="60" x2="182" y2="60" />
      <circle cx="45" cy="60" r="13" />
      <circle cx="95" cy="60" r="13" />
      <circle cx="195" cy="60" r="13" />
    </g>
    <circle cx="145" cy="60" r="13" fill={FILL} fillOpacity="0.22" stroke={FILL} strokeWidth="2.4" />
  </svg>
);

// ---- "How do they actually work?" --------------------------
// A key (accent) approaching a lock: one key fits one lock, the way one
// peptide does one job.
export const KeyAndLock: React.FC = () => (
  <svg className="lp-illus" viewBox="0 0 240 120" role="img" aria-label="One key fits one lock, the way one peptide does one job." fill="none">
    <g stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <rect x="150" y="54" width="58" height="50" rx="9" />
      <path d="M161 54v-8a18 18 0 0 1 36 0v8" />
      <circle cx="179" cy="74" r="5" />
      <line x1="179" y1="79" x2="179" y2="90" />
    </g>
    <g stroke={FILL} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="42" cy="60" r="15" />
      <line x1="57" y1="60" x2="112" y2="60" />
      <line x1="98" y1="60" x2="98" y2="70" />
      <line x1="108" y1="60" x2="108" y2="68" />
    </g>
  </svg>
);

// The "How do people take them?" card intentionally has NO illustration:
// the earlier vial-and-droplet figure read as a candle, so it was removed
// and the card is text-only. The `{Illus && ...}` guard in Peptides101.tsx
// renders nothing when a card id is absent from the map below.

// Keyed by PrimerCard.id so the host can render the right figure per card.
export const PRIMER_ILLUSTRATIONS: Record<string, React.FC> = {
  what: PeptideChain,
  how: KeyAndLock,
};
